module.exports = __webpack_public_path__ + "static/media/Quimica.ee5c8899.svg";